import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const CapitalAllocationCashFlowPlanning = () => {
  const serviceData = {
    title: "Capital Allocation & Cash-Flow Planning",
    heading: "Capital Allocation & Cash-Flow Planning",
    image: subTopicImages["Capital Allocation & Cash-Flow Planning"],
    intro:
      "Effective financial planning and disciplined capital allocation are essential for growth and stability.",
    description: [
      "We support budgeting, forecasting, and strategic capital deployment to ensure your resources are used efficiently and strategically to support growth.",
    ],
    services: [
      {
        title: "Planning & Allocation Support",
        text: "We assist with:",
        list: [
          "budgeting & forecasting",
          "capital deployment strategies",
          "working capital planning",
          "cash flow monitoring & projections",
          "scenario planning",
        ],
        extraInfo:
          "This gives you confidence that your resources are being used efficiently and strategically to support growth.",
      },
    ],
    benefitsIntro: "Why This Matters:",
    benefits: [
      "Disciplined resource management",
      "Accurate cash flow visibility",
      "Scenario-based decision support",
      "Strategic investment alignment",
    ],
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default CapitalAllocationCashFlowPlanning;
